import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import * as style from './Filters.css';
import { trackCategoryClick } from './tracking';
import { IFavoriteCountsSchema } from '../../repositories/favorites/entities/favorite_counts/FavoriteCountsSchema';
import { EDealType } from '../../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';
import { EEntityType, IFiltersState } from '../../types/filters';
import { IResultsState } from '../../types/results';

export interface IFiltersProps {
  filters: IFiltersState;
  results: IResultsState;
  counts: IFavoriteCountsSchema | null;

  setDealType(dealType: EDealType | null): void;
  setFavoriteEntityType(favoriteEntityType: EEntityType | null): void;
  getFavoriteEntities(): void;
}

export const Filters: React.FC<IFiltersProps> = ({
  filters,
  getFavoriteEntities,
  setDealType,
  setFavoriteEntityType,
}) => {
  const handleCategoryClick = (category: EEntityType | null) => {
    setFavoriteEntityType(category);
    setDealType(null);
    getFavoriteEntities();
    trackCategoryClick(category);
  };

  return (
    <div className={style['container']}>
      <div className={style['filters']}>
        <div className={style['filters-header']}>
          <div className={style['header']}>Избранное</div>
        </div>
        <div className={style['row']}>
          <ul className={style['favorites-type']}>
            <li
              onClick={() => handleCategoryClick(null)}
              {...mergeStyles(
                style['favorites-type-item'],
                filters.favoriteEntityType !== EEntityType.Newbuilding && style['favorites-type-item--active'],
              )}
            >
              Объявления
            </li>
            <li
              onClick={() => handleCategoryClick(EEntityType.Newbuilding)}
              {...mergeStyles(
                style['favorites-type-item'],
                filters.favoriteEntityType === EEntityType.Newbuilding && style['favorites-type-item--active'],
              )}
            >
              Жилые комплексы
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
